import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { settingsAPI } from '../../api'
import type { SiteSettings } from '../../types'

// Query key factory for settings
export const settingsKeys = {
  all: ['settings'] as const,
  admin: () => [...settingsKeys.all, 'admin'] as const,
  public: () => [...settingsKeys.all, 'public'] as const,
}

// Fetch public settings for landing page banner (no auth)
export function usePublicSettings() {
  return useQuery({
    queryKey: settingsKeys.public(),
    queryFn: () => settingsAPI.getPublicSettings(),
    staleTime: 60 * 1000, // 60 seconds
  })
}

// Fetch full settings (admin)
export function useSettings() {
  return useQuery({
    queryKey: settingsKeys.admin(),
    queryFn: () => settingsAPI.getSettings(),
  })
}

// Update settings mutation
export function useUpdateSettings() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: Partial<Omit<SiteSettings, 'id' | 'updated_at' | 'theme'>>) =>
      settingsAPI.updateSettings(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: settingsKeys.admin() })
      queryClient.invalidateQueries({ queryKey: settingsKeys.public() })
    },
  })
}
